var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wind") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.41 11.41)",
    stroke: "#6B6B6B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.277,
    cy: 48.277,
    r: 48.277
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.2539 37.932s15.674-7.2102 24.452-6.5832c14.419 0 26.646 21.004 41.067 15.047 14.107-5.9562 16.615-26.722 0-29.543-10.032-1.8809-12.904 4.4642-13.844 8.5395-0.62697 3.4483 1.3047 6.8967 4.1261 8.7776 2.1944 1.5674 13.486 0 6.0182-8.7776",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 49.844s16.928-8.1506 23.511-7.2102c15.831 0 15.988 17.555 37.932 17.555 10.032 0 17.242-8.4641 17.242-8.4641m-76.491 10.659s14.734-7.2102 21.631-6.2697c10.698 0 19.436 25.183 37.932 17.555m-53.293 1.8809s6.2697-7.2102 14.107-6.8967c8.051 0 8.051 13.32 23.817 13.32",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.b594210e0272388f5340a4f96a60f356.svg";
export { ForwardRef as ReactComponent };